import React, { FC } from "react";
import { Footer } from "@highmountainlabs/arclight-ui";

const F: FC<{
  fns: {
    [key: string]: any;
  };
  endpoint?: string;
}> = ({ fns, endpoint }) => (
  <Footer
    logoSrc={`https://titanesports.org:7000/static/media/6580d03bdb096d04c7ad7cf2.png`}
    text={"Titan Esports"}
  />
);

export default F;
